import React, { useState } from 'react';
import { useGoals } from '../../contexts/GoalsContext';
import { PERIOD_LABELS, UNIT_LABELS } from '../../utils/goals';

// The in-app half of the reminder: shown when the app is opened past the chosen
// time with the goal unmet. It cannot reach a closed app — that is what the
// calendar export is for.
const ReminderBanner = ({ onOpen }) => {
  const { goal, progress, now } = useGoals();
  const [dismissed, setDismissed] = useState(false);

  if (!goal || !goal.reminderEnabled || dismissed || !progress || progress.met) return null;

  // Shown once one of the chosen hours has come round today
  const chosen = goal.reminderHours || [];
  if (!chosen.some((hour) => now.getHours() >= hour)) return null;

  return (
    <div
      className="mb-6 p-4 rounded-lg border flex items-start justify-between gap-3"
      style={{ backgroundColor: 'var(--color-light-gray)', borderColor: 'var(--color-light-gold)' }}
      role="status"
    >
      <div className="font-lato text-sm" style={{ color: 'var(--color-charcoal)' }}>
        <strong className="text-heading">Still {progress.remaining} {UNIT_LABELS[goal.unit]} to go</strong>
        <span className="block opacity-80">
          to meet your goal for this {PERIOD_LABELS[goal.period]}.
        </span>
        <button onClick={onOpen} className="underline mt-1 text-heading">
          See progress
        </button>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="opacity-60 hover:opacity-100 shrink-0"
        style={{ color: 'var(--color-charcoal)' }}
        aria-label="Dismiss reminder"
      >
        <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};

export default ReminderBanner;
